import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useTrigger
 */
import { useEffect, useMemo, useState } from 'react';
import { useElementBoundary } from '@tencent/glue-react-boundary';
import { useCombineRef } from '@tencent/glue-react-use';
import { usePopperInstance } from '../context/Popper';
import { useTriggerGroupInstance } from '../context/TriggerGroup';
export function useTrigger(getTrigger, options, captureOptions, triggerType, triggerId) {
  var popper = usePopperInstance();
  var triggerGroup = useTriggerGroupInstance();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _options$disabled = options.disabled,
      disabled = _options$disabled === void 0 ? false : _options$disabled,
      data = options.data,
      disableToggleClose = options.disableToggleClose;
  var trigger = useMemo(function () {
    return getTrigger(popper, triggerType, triggerGroup, triggerId);
  }, []);
  trigger.updateTriggerOptions({
    disabled: disabled,
    data: data,
    disableToggleClose: disableToggleClose
  });

  var _useElementBoundary = useElementBoundary(function () {
    return trigger.isFocus() || trigger.isActiveShow();
  }, function (rect) {
    return trigger.updateRect(rect);
  }, captureOptions),
      _useElementBoundary2 = _slicedToArray(_useElementBoundary, 2),
      ref = _useElementBoundary2[0],
      force = _useElementBoundary2[1];

  var reference = useCombineRef(ref, function (node) {
    trigger.updateReference(node);

    if (node) {
      node.setAttribute('data-rc-id', "trigger___".concat(trigger.getId()));
    }
  });
  useEffect(function () {
    var callback = function callback(active) {
      force();
      setActive(active);
    };

    trigger.addListener('update-active', callback);
    return function () {
      trigger.removeListener('update-active', callback);
      trigger.dispose();
    };
  }, []);
  return [reference, trigger, active];
}